import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import '../assets/scss/components/sectionTitle.css';

class SectionTitle extends React.Component {
    render() {
        let pageTitle = false;
        if (this.props.cssClass.includes('page-title')) {
            pageTitle = true;
        }

        return (
            <div className={classnames('row no-gutters section-title', this.props.cssClass)}>
                <div className={classnames('col', { ['col-lg-8 col-md-12 offset-lg-2 offset-md-0']: !pageTitle, ['col-12 col-sm-9']: pageTitle })}>
                    <h2>{this.props.title}</h2>
                    {this.props.subtitle ? <div className="subtitle">{ReactHtmlParser(this.props.subtitle)}</div> : null}
                </div>
            </div>
        )
    }
}

SectionTitle.propTypes = {
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    subtitle: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    cssClass: PropTypes.string,
};

export default SectionTitle;


// WEBPACK FOOTER //
// ./src/features/Layout/components/SectionTitle.js